import { Component, OnInit, Input } from '@angular/core';
import { CartService } from 'src/app/services/api/cart.service';
import { environment as env } from "src/environments/environment";
import { BsModalService, BsModalRef, ModalOptions } from "ngx-bootstrap/modal";
import { TshirtArtworkComponent } from 'src/app/components/modals/tshirt-artwork/tshirt-artwork.component';
import { TshirtPrintLimitationComponent } from 'src/app/components/modals/tshirt-print-limitation/tshirt-print-limitation.component';
import { CmsService } from 'src/app/services/api/cms.service';
import { FbpixelService } from 'src/app/services/api/fbpixel.service';

@Component({
  selector: 'app-product-t-shirt-options',
  templateUrl: './product-t-shirt-options.component.html',
  styleUrls: ['./product-t-shirt-options.component.scss']
})
export class ProductTShirtOptionsComponent implements OnInit {

	@Input() product:any = null;
	modalRef: BsModalRef;

	activeOpt:any = "";
	activeFW:any = {
		color: "",
		print_location: "",
		sizes: ""
	};

	productOptions:any = {
		colors: null,
		print_location: null,
		print_size: {},
		sizes: []
	};
	selectedProductOptions:any = {
		color: null,
		print_location: {},
		sizes: {}
	};

	selectedPrinteLocationNames:any = null;

	pricePerShirt:any = 0;

	/**
	 * modal initial data
	 */
	limitationHtmlContent: any = null
	sizeChartHtmlContent: any = null

	entrlabelCustomTShirtShipp: any = 0;

	// maxWidth: any = 33;
	// maxHeight: any = 48;
	printMaxSize: any = null;

	minQtyForInsideTags: number = 20;

	constructor(
		public cartService: CartService,
		public modalService: BsModalService,
		public cms: CmsService,
		public fbpixel: FbpixelService
	) { }

	ngOnInit(): void {
		this.setOptions();
		this.cms.getHndCmsPage('t-shirt-limitation-modal-info', true, false).then(content => {
			this.limitationHtmlContent = content.content
		});
		this.cms.getHndCmsPage('t-shirt-size-chart-modal-info', true, false).then(content => {
			this.sizeChartHtmlContent = content.content
		});
	}

	resetSelected(){
		this.selectedProductOptions = {
			color: null,
			print_location: {},
			sizes: {}
		};
		this.selectedPrinteLocationNames = null;

		this.productOptions.print_size['Back Size'].height_value = '';
		this.productOptions.print_size['Back Size'].width_value = '';
		this.productOptions.print_size['Front Size'].height_value = '';
		this.productOptions.print_size['Front Size'].width_value = '';
		this.productOptions.print_size['Inside Tag Size'].height_value = '';
		this.productOptions.print_size['Inside Tag Size'].width_value = '';
		this.productOptions.print_size['Left Arm Size'].height_value = '';
		this.productOptions.print_size['Left Arm Size'].width_value = '';
		this.productOptions.print_size['Right Arm Size'].height_value = '';
		this.productOptions.print_size['Right Arm Size'].width_value = '';

		this.productOptions.sizes.forEach(size => {
			size._value = "";
		});

		this.setActiveOpt('');
	}

	setOptions(){
		this.product.options.forEach((option, optIndex) => {
			let printSizeValues = ['Front Size', 'Back Size', 'Left Arm Size', 'Right Arm Size', 'Inside Tag Size'];
			if(option.title == 'Color'){
				option.values.forEach((color, valIndex) => {
					let title = color.title.split('-');
					if(title.length == 2){
						this.product.options[optIndex].values[valIndex]["_title"] = title[0];
						this.product.options[optIndex].values[valIndex]["hex_code"] = title[1];
						this.product.options[optIndex].values[valIndex]["option_id"] = this.product.options[optIndex].option_id;
					}
				});
				this.productOptions.colors = this.product.options[optIndex].values;
			}
			else if(option.title == 'Print Location'){
				option.values.forEach((printLocation, valIndex) => {
					let iconFileName:string = printLocation.title.replace(' ', '-').toLocaleLowerCase();
					let iconUrl = env.baseUrl + '/media/entrelabel/t-shirt-option-print-location/'+iconFileName+'.jpg';
					this.product.options[optIndex].values[valIndex]["icon_image"] = iconUrl;
					this.product.options[optIndex].values[valIndex]["option_id"] = this.product.options[optIndex].option_id;
				});
				this.productOptions.print_location = this.product.options[optIndex].values;
			}
			else if(this.cms.inArray(option.title, printSizeValues)){
				option['width_value'] = '';
				option['height_value'] = '';
				option['_value'] = '';
				this.productOptions.print_size[option.title] = option;
			}
			else if(option.title.match(/Size-/gi)){
				option['_title'] = option.title.replace('Size-', '');
				option['_value'] = '';
				if(option['_title'] == 'M'){
					option['_value'] = '';
				}
				option["option_id"] = this.product.options[optIndex].option_id;
				this.productOptions.sizes.push(option);
			}
		});


		this.product.custom_attributes.forEach((ca) => {
			if(ca.attribute_code == 'entrlabel_custom_t_shirt_shipp'){
				this.entrlabelCustomTShirtShipp = parseFloat(ca.value);
			}
			else if(ca.attribute_code == 'custom_block'){
				this.printMaxSize = JSON.parse(ca.value);
			}
		});
	}

	setActiveOpt(opt: any = "", collapse:boolean = true) {
		this.activeFW = {
			color: "",
			print_location: ""
		};

		if (this.activeOpt == opt) {
			if(collapse){
				this.activeOpt = "";
			} else {
				this.activeOpt = opt;
				this.activeFW[opt] = "fw-800";
			}
		} else {
			this.activeOpt = opt;
			this.activeFW[opt] = "fw-800";
		}
	}

	setSelectedColor(color){
		this.selectedProductOptions['color'] = color
	}

	setSelectedPrintLocation(print_location){
		if(typeof this.selectedProductOptions['print_location']['_' + print_location.option_type_id] == 'undefined'){
			this.selectedProductOptions['print_location']['_' + print_location.option_type_id] = print_location;
		}
		else {
			delete this.selectedProductOptions['print_location']['_' + print_location.option_type_id];
		}

		let pl = Object.keys(this.selectedProductOptions.print_location);
		let selectedPLNames = [];
		pl.forEach(key => {
			selectedPLNames.push(this.selectedProductOptions.print_location[key].title);
		});
		this.selectedPrinteLocationNames = selectedPLNames.join(', ');
	}

	isNumberKey(evt:any, hasDecimal:boolean=false){
		let charCode = evt.which ? evt.which : evt.keyCode;
		if (
			charCode == 8 ||
			charCode == 9 ||
			(charCode >= 96 && charCode <= 105) ||
			(charCode >= 48 && charCode <= 57) ||
			(charCode >= 37 && charCode <= 40)
		) {
			return true;
		} else {
			if(hasDecimal){
				if(charCode == 110 || charCode == 190){
					return true;
				} else {
					return false;
				}
			}
			else {
				return false;
			}
		}
	}

	get hasInsideTag(){
		let pl = Object.keys(this.selectedProductOptions.print_location);
		let selectedPrintLocationTitles = [];
		pl.forEach((key) => {
			selectedPrintLocationTitles.push(this.selectedProductOptions.print_location[key].title);
		});

		return this.cms.inArray('Inside Tag', selectedPrintLocationTitles);
	}

	uploadArtWork(){
		let pl = Object.keys(this.selectedProductOptions.print_location);
		let canContinue = true;

		if(!this.selectedProductOptions.color){
			canContinue = false;
			this.cartService.toastService.add('Please select apparel color', 'danger');
		}
		else if(!this.totalTshirts){
			canContinue = false;
			this.cartService.toastService.add('Please add qty in sizes', 'danger');
		}
		else if(!pl.length){
			canContinue = false;
			this.cartService.toastService.add('Please select print location', 'danger');
		}
		
		pl.forEach((key) => {
			let sizeKey = this.selectedProductOptions.print_location[key].title + ' Size';
			let plSize = this.productOptions.print_size[sizeKey];
			
			if(!plSize.width_value.length || !plSize.height_value.length){
				this.cartService.toastService.add('Please input the print size.', 'danger');
				canContinue = false;
			}
			else {
				if(parseFloat(plSize.width_value) < parseFloat(this.printMaxSize[sizeKey].width.min)){
					canContinue = false;
					this.cartService.toastService.add('Min-width for ' + sizeKey + ' that can be printed is '+this.printMaxSize[sizeKey].width.min+'cm', 'danger');
				}
				else if(parseFloat(plSize.width_value) >  parseFloat(this.printMaxSize[sizeKey].width.max)){
					canContinue = false;
					this.cartService.toastService.add('Max-width for ' + sizeKey + ' that can be printed is '+this.printMaxSize[sizeKey].width.max+'cm', 'danger');
				}

				if(parseFloat(plSize.height_value) < parseFloat(this.printMaxSize[sizeKey].height.min)){
					canContinue = false;
					this.cartService.toastService.add('Min-height for ' + sizeKey + ' that can be printed is '+this.printMaxSize[sizeKey].height.min+'cm', 'danger');
				}
				else if(parseFloat(plSize.height_value) > parseFloat(this.printMaxSize[sizeKey].height.max)){
					canContinue = false;
					this.cartService.toastService.add('Max-height for ' + sizeKey + ' that can be printed is '+this.printMaxSize[sizeKey].height.max+'cm', 'danger');
				}
			}
		});

		setTimeout(() => {
			if(this.hasInsideTag && this.totalTshirts < this.minQtyForInsideTags){
				canContinue = false;
				this.cartService.toastService.add('For customized Inside Tag print, the minimum order qty is '+this.minQtyForInsideTags+' pieces total.', 'danger');
			}
			setTimeout(() => {
				if(canContinue){
					this.fbPixel();

					let config: ModalOptions = {
						backdrop: "static",
						keyboard: false,
						animated: true,
						ignoreBackdropClick: true,
						initialState: {
							product: this.product,
							selectedProductOptions: this.selectedProductOptions,
							productOptions: this.productOptions,
							selectedQtyPrice: this.total,
							awupload: "addtocart"
						}
					};
					this.modalRef = this.modalService.show(TshirtArtworkComponent, config);
					this.modalRef.setClass("t-shirt-artwork-modal artwork-modal modal-dialog-centered");
					this.modalRef.content.onClose = (myData) => {
						this.modalRef.hide();
						this.fbPixel('AddToCart');

						if(typeof myData['item_id'] != 'undefined'){
							setTimeout(() => {
								this.resetSelected();
							}, 500);
						}
					};
				}
			}, 50);
		}, 50);
	}

	get totalTshirts(){

		let qty = 0;
		this.productOptions.sizes.forEach(size => {
			if(size._value){
				qty += parseInt(size._value);
			}
		});
		return qty;
	}

	get total(){
		let total:any = this.product.price;

		let plPrice = 0;
		let objKeys = Object.keys(this.selectedProductOptions.print_location);
		objKeys.forEach(key => {
			let pl = this.selectedProductOptions.print_location[key];
			plPrice += pl.price;
		});

		if(this.totalTshirts){
			if(this.entrlabelCustomTShirtShipp > 0){
				total = (this.totalTshirts * (total + plPrice)) + this.entrlabelCustomTShirtShipp;
			}
			else {
				total = this.totalTshirts * (total + plPrice);
			}
		}
		else {
			total = 0;
		}

		if(total && plPrice){
			this.pricePerShirt = total / this.totalTshirts;
		}
		else {
			total = 0;
			this.pricePerShirt = 0;
		}

		return total;
	}

	openLimitationModal(type:string='limitation'){
		
		let cmsContent: any = this.sizeChartHtmlContent;
		let modalDialogClass = 'modal-dialog info-modal modal-dialog-centered product-info tshirt-size-chart-modal';
		if(type == 'limitation'){
			cmsContent = this.limitationHtmlContent;
			modalDialogClass = 'modal-dialog info-modal modal-dialog-centered product-info tshirt-print-limitation-modal';
		}

		let config: ModalOptions = {
			backdrop: "static",
			keyboard: false,
			animated: true,
			ignoreBackdropClick: true,
			initialState: {
				cmsContent: cmsContent
			}
		};

		this.modalRef = this.modalService.show(TshirtPrintLimitationComponent, config);
		this.modalRef.setClass(modalDialogClass);
		this.modalRef.content.onClose = (myData) => {
			this.modalRef.hide();
		};
	}

	/**
	 * the pixel here is only for ViewContent event
	 * @param event 
	 */
	fbPixel(event = 'ViewContent'){

		let price = this.pricePerShirt;

		if(price > 0){
			let fbqData = {
				content_name: this.product.sku,
				content_category: 'Default',
				content_ids: [this.product.id],
				content_type: 'product',
				value: price,
				currency: 'PHP'
			}
			this.fbpixel.fbq('track', event, JSON.parse(JSON.stringify(fbqData)));
	
			let ttqData = {  
				contents: [
					{
						content_id: this.product.id + '',
						content_name: this.product.sku,
						quantity: this.totalTshirts,
						price: price,
					}
				],
				content_type: 'product',
				value: this.total,
				currency: 'PHP',  
			}
			this.fbpixel.ttq(event, JSON.parse(JSON.stringify(ttqData)));
		}
	}
}
